import { all, AllEffect } from 'redux-saga/effects';
import ReportsReducer from './duck/reducer';
import { watchGetReports } from './duck/saga';

function* ReportsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetReports()]);
}

export { ReportsReducer, ReportsSaga };
